import { db } from "../../firebase";
import Vue from "vue";
const state = {
  healthData: {},
  status: ""
};
const mutations = {
  fetchHealth(state, payload) {
    state.healthData = payload;
    state.status = "fetch";
  },
  setHealth(state, date, payload) {
    Vue.set(state.healthData, date, payload);
    state.status = "set";
  },
  deleteHealth(state, date) {
    Vue.Delete(state.healthData, date);
    state.status = "delete";
  },
  clear(state) {
    state.healthData = {};
    state.status = "";
  }
};
const actions = {
  fetchHealth({ commit }, payload) {
    commit("fetchHealth", payload);
  },
  setHealth({ commit }, date, payload) {
    commit("setHealth", date, payload);
  },
  deleteHealth({ commit }, date, payload) {
    commit("deleteHealth", date, payload);
  },
  // Firebaseから全てのからだ手帳データを取得
  async fetchHealthFromFirebase({ commit }, uid) {
    try {
      const snapshot = await db.ref(`/health/${uid}`).once("value");
      if (snapshot.val()) {
        commit("fetchHealth", snapshot.val());
      } else {
        commit("fetchHealth", {});
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  },
  // Firebaseに指定した日付のからだ手帳データを新規登録、上書き
  async sendHealthToFirebase({ dispatch, commit, state }, payload) {
    // 指定した日付のデータが存在する場合
    if (Object.keys(state.healthData).find(v => v.key === payload.date)) {
      // 日付が存在する場合はアップデート
      dispatch("updateHealthToFirebase", {
        uid: payload.uid,
        date: payload.date,
        payload: payload.healthData
      });
    } else {
      try {
        await db
          .ref(`/health/${payload.uid}/${payload.date}`)
          .set(payload.healthData);
        commit("setHealth", payload.date, payload.healthData);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error.message);
      }
    }
  },
  // Firebaseに指定した日付のからだ手帳データをアップデート
  async updateHealthToFirebase({ commit }, payload) {
    try {
      await db
        .ref(`/health/${payload.uid}/${payload.date}`)
        .update(payload.healthData);
      commit("setHealth", payload.date, payload.healthData);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  },
  // Firebaseに指定した日付のからだ手帳データを削除
  async deleteHealthToFirebase({ commit }, uid, date) {
    try {
      await db.ref(`/health/${uid}/${date}`).update(null);
      commit("deleteHealth", date);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  }
};

const getters = {
  getHealthData: state => {
    return state.healthData;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
